<!-- ============================================================== -->
<!-- Language - i18n Translation -->
<!-- ============================================================== -->
<div class="d-flex justify-content-between align-items-center">

  <!--INFO:
  Part of the code will be temporary frozen. I put in comment because it could be
  whether we re-activate the languages after deployment or if there are users who request to have
  the option to change the language -->
  <!-- <div [ngClass]="{'d-none d-sm-flex': tokenExpiringIn> 0}"
  [ngClass]="{'d-sm-none d-md-flex': tokenExpiringIn> 0}">
  <button [matMenuTriggerFor]="language"
    mat-icon-button>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <mat-icon>language</mat-icon>
      {{ 'profile.language' | translate }}
    </div>

  </button>
  <mat-menu #language="matMenu"
    class="mymegamenu">
    <button mat-menu-item
      (click)="useLanguage('en')">
      <mat-icon>language</mat-icon>English
    </button>
    <button mat-menu-item
      (click)="useLanguage('fr')">
      <mat-icon>language</mat-icon>Français
    </button>
  </mat-menu>
</div> -->


<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
@if (tokenExpiringIn > 0 && !userLoading) {
  <div class="renew-session-container">
    <div class="renew-session-section">
      <div class="welcome">
        <span>{{ 'profile.sessionExpiring.line1' | translate: {timeLeft: tokenExpiringIn * 1000 | date:'m:ss'} }}</span>
      </div>
    </div>
    <div class="renew-session-spacer"></div>
    <div class="renew-session-section">
      <button mat-raised-button
        [disabled]="userLoading"
        (click)="renewSession()">
        <mat-icon>next_plan</mat-icon>
        <span [ngClass]="{'d-none d-sm-flex': tokenExpiringIn > 0}">{{ 'profile.renew' | translate }}</span>
      </button>
    </div>
  </div>
} @else {
  <div class="nameContainer">
    @if (isAuthorized) {
      <span
        class="welcome">
        <span class="d-none d-sm-inline">{{ 'profile.welcome' | translate }}</span> {{user?.name}}
      </span>
    }
  </div>
}
@if (!userLoading) {
  <button
    [ngClass]="{'d-none d-md-flex': tokenExpiringIn > 0}"
    [matMenuTriggerFor]="profile"
    mat-button
    >
    <img src="assets/images/users/user-blank.png"
      alt="user"
      class="profile-pic">
    </button>
  } @else {
    @if (userLoading) {
      <mat-spinner
      diameter="20"></mat-spinner>
    }
  }
  <mat-menu #profile="matMenu"
    class="mymegamenu">
    @if (!isAuthorized) {
      <button mat-menu-item
        (click)="login()">
        <mat-icon>lock_open</mat-icon> {{ 'profile.sign_in' | translate }}
      </button>
    }
    @if (isAuthorized) {
      <button mat-menu-item
        (click)="logout()">
        <mat-icon>exit_to_app</mat-icon> {{ 'profile.sign_out' | translate }}
      </button>
    }
    <button mat-menu-item
      (click)="resetPassword()">
      <mat-icon>password</mat-icon> {{ 'profile.resetPassword' | translate }}
    </button>
  </mat-menu>
</div>


